import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, createElementVNode as _createElementVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-35a1214c"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "media-input" }
const _hoisted_2 = { class: "btns" }
const _hoisted_3 = { class: "btns" }

import { ref } from 'vue'
import message from '@/utils/message'
import Tabs from '@/components/Tabs.vue'
import Input from '@/components/Input.vue'
import Button from '@/components/Button.vue'

type TypeKey = 'video' | 'audio'
interface TabItem {
  key: TypeKey
  label: string
}


export default /*#__PURE__*/_defineComponent({
  __name: 'MediaInput',
  emits: ["insertVideo", "insertAudio", "close"],
  setup(__props, { emit: __emit }) {

const emit = __emit

const type = ref<TypeKey>('video')

const videoSrc = ref('https://mazwai.com/videvo_files/video/free/2019-01/small_watermarked/181004_04_Dolphins-Whale_06_preview.webm')
const audioSrc = ref('https://freesound.org/data/previews/614/614107_11861866-lq.mp3')

const tabs: TabItem[] = [
  { key: 'video', label: '视频' },
  { key: 'audio', label: '音频' },
]

const insertVideo = () => {
  if (!videoSrc.value) return message.error('请先输入正确的视频地址')
  emit('insertVideo', videoSrc.value)
}

const insertAudio = () => {
  if (!audioSrc.value) return message.error('请先输入正确的音频地址')
  emit('insertAudio', audioSrc.value)
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(Tabs, {
      tabs: tabs,
      value: type.value,
      "onUpdate:value": _cache[0] || (_cache[0] = ($event: any) => ((type).value = $event)),
      tabsStyle: { marginBottom: '15px' }
    }, null, 8, ["value"]),
    (type.value === 'video')
      ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
          _createVNode(Input, {
            value: videoSrc.value,
            "onUpdate:value": _cache[1] || (_cache[1] = ($event: any) => ((videoSrc).value = $event)),
            placeholder: "请输入视频地址，e.g. https://xxx.mp4"
          }, null, 8, ["value"]),
          _createElementVNode("div", _hoisted_2, [
            _createVNode(Button, {
              onClick: _cache[2] || (_cache[2] = ($event: any) => (emit('close'))),
              style: {"margin-right":"10px"}
            }, {
              default: _withCtx(() => [
                _createTextVNode("取消")
              ]),
              _: 1
            }),
            _createVNode(Button, {
              type: "primary",
              onClick: _cache[3] || (_cache[3] = ($event: any) => (insertVideo()))
            }, {
              default: _withCtx(() => [
                _createTextVNode("确认")
              ]),
              _: 1
            })
          ])
        ], 64))
      : _createCommentVNode("", true),
    (type.value === 'audio')
      ? (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
          _createVNode(Input, {
            value: audioSrc.value,
            "onUpdate:value": _cache[4] || (_cache[4] = ($event: any) => ((audioSrc).value = $event)),
            placeholder: "请输入音频地址，e.g. https://xxx.mp3"
          }, null, 8, ["value"]),
          _createElementVNode("div", _hoisted_3, [
            _createVNode(Button, {
              onClick: _cache[5] || (_cache[5] = ($event: any) => (emit('close'))),
              style: {"margin-right":"10px"}
            }, {
              default: _withCtx(() => [
                _createTextVNode("取消")
              ]),
              _: 1
            }),
            _createVNode(Button, {
              type: "primary",
              onClick: _cache[6] || (_cache[6] = ($event: any) => (insertAudio()))
            }, {
              default: _withCtx(() => [
                _createTextVNode("确认")
              ]),
              _: 1
            })
          ])
        ], 64))
      : _createCommentVNode("", true)
  ]))
}
}

})